/**
 * AccessDeniedPage - Страница "Доступ запрещен"
 *
 * Отображается когда пользователь пытается получить доступ
 * к разделу, для которого у него нет прав
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Title,
  Text,
  Button,
  Stack,
  ThemeIcon,
  Card,
} from '@mantine/core';
import { IconLock, IconArrowLeft, IconHome } from '@tabler/icons-react';
import tokens from '../theme/designTokens';

const AccessDeniedPage = ({ message = 'У вас нет прав для доступа к этому разделу' }) => {
  const navigate = useNavigate();

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <Card shadow="sm" padding="xl" radius="md" style={{ maxWidth: 480, width: '100%' }}>
        <Stack align="center" gap="lg">
          <ThemeIcon
            size={80}
            radius="xl"
            color="red"
            variant="light"
          >
            <IconLock size={40} />
          </ThemeIcon>

          <Title order={2} ta="center" c={tokens.colors.neutral[9]}>
            Доступ запрещен
          </Title>

          <Text size="md" c={tokens.colors.neutral[7]} ta="center">
            {message}
          </Text>

          <Text size="sm" c={tokens.colors.neutral[6]} ta="center">
            Обратитесь к администратору системы для получения необходимых прав доступа.
          </Text>

          <Stack gap="sm" w="100%" mt="md">
            <Button
              variant="filled"
              leftSection={<IconHome size={18} />}
              onClick={() => navigate('/')}
              fullWidth
            >
              На главную
            </Button>
            <Button
              variant="subtle"
              leftSection={<IconArrowLeft size={18} />}
              onClick={() => navigate(-1)}
              fullWidth
            >
              Вернуться назад
            </Button>
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
};

export default AccessDeniedPage;
